import React, { useState } from "react";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { IoCloseSharp } from "react-icons/io5";
import { IoMdCloudDownload } from "react-icons/io";
import { useTranslation } from "react-i18next";

const DocumentPreview = ({ preview, size }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const handleDownload = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = "document.pdf"; // Set the desired filename here
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      {preview && (
        <a
          className={`${
            size === "small" ? "addDriver" : "addVehicle"
          } me-2 d-flex align-items-center justify-content-center`}
          onClick={() => setIsOpen(true)}
        >
          Preview
        </a>
      )}
      <Modal className="driverInfoPopup" show={isOpen}>
        <div className="closePopup downloadBtn" style={{ marginRight: "4rem" }}>
          <button
            style={{ borderRadius: "2px", padding: "2px" }}
            onClick={() => handleDownload(preview)}
          >
            <IoMdCloudDownload />
          </button>
        </div>
        <div className="closePopup downloadBtn" style={{ top: "1px" }}>
          <Button className="closePopup" onClick={() => setIsOpen(false)}>
            <IoCloseSharp />
          </Button>
        </div>
        {/* {preview ? (
          preview.endsWith(".xlsx") ||
          preview.endsWith(".xls") ||
          preview.endsWith(".csv") ? (
            <iframe
              src={`https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
                preview
              )}`}
              style={{ width: "100%", height: "600px", border: "none" }}
              title="Excel Viewer"
            />
          ) : ( */}
        <DocViewer
          prefetchMethod="get"
          documents={[{ uri: preview }]}
          pluginRenderers={DocViewerRenderers}
        />
        {/* )
        ) : null} */}

        {/* <DriverInfo id={id} /> */}
      </Modal>
    </>
  );
};

export default DocumentPreview;
